import Header42 from './Header42'
export default Header42
